import { ReactElement } from "react";

/**
 * Splits a string on backticks and wraps alternating segments in <strong>.
 * @param text The input string with optional backtick-wrapped sections.
 * @returns An array of React nodes with <strong> wrapping backtick segments.
 */
export function boldenBacktickText(text: string): ReactElement[] {
  return text.split("`").map((segment, index) => {
    const key = `part-${index}`;

    return index % 2 === 0
      ? <span key={key}>{ segment }</span>
      : <strong key={key}>{ segment }</strong>;
  });
}
